import { render } from "./Relatorios.vue?vue&type=template&id=19dc477f&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"

import "./Relatorios.vue?vue&type=style&index=0&id=19dc477f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dc477f"]])

export default __exports__